export const SEARCH_CARD_MAX_VISIBLE_DATES = 3;
export const SEARCH_CARD_LABELS_FR = {
  seeMore: 'Voir plus',
  waitingList: "Liste d'attente ouverte",
  newBadge: 'New',
  targetAudience: {
    jobseeker: "Chercheur d'emploi",
    all: 'Tout public',
    enterprise: 'Travailleur',
    teacher: 'Enseignant'
  },
  productType: {
    short: 'Formation courte',
    parcours: 'Parcours métier pour les chercheurs d’emploi'
  }
};
export function searchCardActionsCount(formation) {
  return formation.actionsCount ?? 0;
}
export function searchCardExtraDatesCount(formation) {
  return Math.max(searchCardActionsCount(formation) - 1, 0);
}
export function searchCardShowDateCounter(formation) {
  return searchCardExtraDatesCount(formation) > 0;
}
export function searchCardVisibleUpcomingActions(formation) {
  if (searchCardActionsCount(formation) <= 1) {
    return [];
  }
  return (formation.upcomingActions ?? []).slice(0, SEARCH_CARD_MAX_VISIBLE_DATES);
}
export function searchCardRemainingDatesCount(formation) {
  const visible = searchCardVisibleUpcomingActions(formation);
  if (visible.length === 0) {
    return 0;
  }
  return Math.max(searchCardActionsCount(formation) - visible.length, 0);
}
export function searchCardHasWaitingList(formation) {
  return formation.waitingListSlug != null;
}
export function searchCardShowSessionRow(formation) {
  return searchCardVisibleUpcomingActions(formation).length > 0 || searchCardHasWaitingList(formation);
}
export function searchCardExtraDatesLabel(count) {
  return `+${count}`;
}
export function searchCardMoreDatesLabel(count) {
  return count === 1 ? '+1 autre' : `+${count} autres`;
}
export function searchCardProductSlugForDates(formation) {
  return formation.productSlug ?? (formation.resourceType === 'product' ? formation.slug : undefined);
}
export function searchCardDetailHref(frontUrl, formation) {
  const base = frontUrl.replace(/\/$/, '');
  if (formation.resourceType === 'product') {
    return `${base}/catalogue/formation/${formation.slug}`;
  }
  return `${base}/catalogue/action/${formation.slug}`;
}
export function searchCardProductHref(frontUrl, productSlug) {
  const base = frontUrl.replace(/\/$/, '');
  return `${base}/catalogue/formation/${productSlug}`;
}
export function searchCardActionHref(frontUrl, actionSlug) {
  const base = frontUrl.replace(/\/$/, '');
  return `${base}/catalogue/action/${actionSlug}`;
}
export function searchCardApplyHref(frontUrl, waitingListSlug) {
  const base = frontUrl.replace(/\/$/, '');
  return `${base}/catalogue/action/${waitingListSlug}/inscription`;
}
export function searchCardCoverUrl(options) {
  const {
    formation,
    staticUrl,
    frontUrl
  } = options;
  if (formation.coverImage) {
    return `${staticUrl.replace(/\/$/, '')}/covers/${formation.coverImage}`;
  }
  const placeholderBase = frontUrl ? `${frontUrl.replace(/\/$/, '')}/assets/images` : '/assets/images';
  const audienceKey = formation.targetAudience ?? '';
  return `${placeholderBase}/${audienceKey}-placeholder.png`;
}
export function searchCardTargetAudienceLabel(targetAudience) {
  if (!targetAudience) {
    return null;
  }
  return SEARCH_CARD_LABELS_FR.targetAudience[targetAudience] ?? null;
}
export function searchCardProductTypeLabel(productType) {
  if (!productType) {
    return null;
  }
  return SEARCH_CARD_LABELS_FR.productType[productType] ?? null;
}